export default __webpack_public_path__ + "static/solid-surface-d3ae5e6a3d923da978c9612615aa7a97.jpg";